var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24ZM12 7.71429C12.6857 7.71429 13.2857 7.11429 13.2857 6.42857C13.2857 5.74286 12.6857 5.14286 12 5.14286C11.3143 5.14286 10.7143 5.74286 10.7143 6.42857C10.7143 7.11429 11.3143 7.71429 12 7.71429ZM12.8571 16.2857H14.5714V18H9.42857V16.2857H11.1429V11.1429H9.42857V9.42857H12.8571V16.2857Z",
    fill: "#066FEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcons);
export default __webpack_public_path__ + "static/media/notification-icons.2a57160227f612776e0999922ac4c908.svg";
export { ForwardRef as ReactComponent };